import { Link } from 'react-router-dom';
import { navSites, siteCategories } from '@/mocks/navigation';

export default function CategoryGrid() {
  const countOf = (id: string) => navSites.filter((site) => site.category === id).length;

  return (
    <section id="categories" aria-labelledby="categories-title" className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-100">
      <div className="max-w-2xl">
        <span className="font-label text-xs tracking-[0.2em] text-primary-600">CATEGORIES</span>
        <h2 id="categories-title" className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          按领域归好的网站目录
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600">
          十个分类各自独立成页，同类站点集中摆放。想找哪个方向，直接进分区顺着看就行。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        {siteCategories.map((category) => (
          <Link
            key={category.id}
            to={`/category/${category.id}`}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 transition-colors hover:border-primary-300"
          >
            <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-800 text-xl">
              <i className={category.icon} aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{category.name}</h3>
            <p className="mt-1 font-label text-[11px] text-secondary-700">{category.tagline}</p>
            <p className="mt-3 text-xs leading-relaxed text-foreground-600 line-clamp-2">{category.desc}</p>
            <span className="mt-4 flex items-center justify-between font-label text-xs text-foreground-500">
              <span>收录 {countOf(category.id)} 个站点</span>
              <i className="ri-arrow-right-line text-primary-500 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}